import { Observable, of } from 'rxjs'
import { catchError, merge } from 'rxjs/operators'

import { Task } from '@skinsoft/types'
import { taskSelectors } from '@skinsoft/selectors'
import { HistoryRecord } from '@skinsoft/ui'
import { resolveAuthor } from '../../resolve-author'
import { resolveDescription } from './resolve-description'

export function toHistoryRecord$(task: Task): Observable<HistoryRecord> {
    const featured: HistoryRecord = {
        author: taskSelectors.author(task),
        date: taskSelectors.endDate(task),
        description: taskSelectors.associatedTasks(task)[0],
        id: task.id,
        title: taskSelectors.incrementalTitle(task),
    };

    const featured$ = of(featured);

    return featured$.pipe(
        merge(
            of({ ...featured, author: null } as HistoryRecord),
            featured$.pipe(
                resolveAuthor,
                resolveDescription,
            ),
        ),
        catchError(error => of({ ...featured, author: error })),
    );
}
